module.exports = __webpack_public_path__ + "img/sfn_logo.0f9d9571.png";